module.exports = __webpack_public_path__ + "static/media/bicikl_potraznja.f9edcbbb.png";